import {
  ACTION_GET_EXPENSE_EXPORT_MODELS,
  ACTION_GET_EXPENSE_EXPORT_MODELS_SUCCESS,
  ACTION_GET_EXPENSE_EXPORT_MODELS_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';
import { Dispatch } from 'redux';
import { enqueueSnackbarHandler } from '../Status';

export function getExpenseExportModels(organizationId: string) {
  return (dispatch: Dispatch) => {
    dispatch(requestStarted());
    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/expense-exports`,
        method: 'get',
        data: {},
        success: (response: any) => {
          if (response.type === 'error') {
            enqueueSnackbarHandler(dispatch, response.payload.payload, 'error');
            dispatch(requestFailed(response));
          } else {
            dispatch(requestSuccess(response.payload));
          }
        },
        fail: (error: any) => {
          if (error.payload) {
            enqueueSnackbarHandler(dispatch, error.payload, 'error');
          }
          dispatch(requestFailed(error));
        },
      },
    });
  };
}

export function requestStarted() {
  return {
    type: ACTION_GET_EXPENSE_EXPORT_MODELS,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_GET_EXPENSE_EXPORT_MODELS_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_GET_EXPENSE_EXPORT_MODELS_FAILURE,
    payload: responseJSON,
  };
}